import React from "react";
import { object } from "prop-types";

import NewsWithImage from "../../molecules/NewsWithImage";
import ComponentContainer from "../../layouts/component-container";
import CustomSlider from "../../atoms/CustomSlider";

import { useDevice } from "../../utils/react-utils";

import "./fiveVideoStories.m.css";

const FiveVideoStories = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const { mobile } = useDevice();
  const { items = [] } = collection;

  const stories = items.filter(({ type }) => type === "story").map(({ story }) => story);

  if (!stories.length) return null;

  return (
    <ComponentContainer styleName="outer-wrapper" collection={collection} arrowColor="#ffb300">
      {mobile !== undefined &&
        (mobile ? (
          <CustomSlider
            isNavigation={false}
            slidesPerView={{ mobileSlides: 1.25, tabSlides: 1.25 }}
            spacing={{ mobileSpace: 16, tabSpace: 16 }}
          >
            {stories.map((story) => (
              <NewsWithImage key={story.id} story={story} aspectRatio={[16, 9]} imageType="image16x9" widths={[320]} />
            ))}
          </CustomSlider>
        ) : (
          <div styleName="wrapper">
            {stories.map((item, index) => (
              <NewsWithImage
                key={item.id}
                aspectRatio={[16, 9]}
                imageType="image16x9"
                story={item}
                styleName={`item${index + 1}`}
                widths={index === 0 ? [320, 470, 720] : [320, 300, 488]}
              />
            ))}
          </div>
        ))}
    </ComponentContainer>
  );
};

FiveVideoStories.propTypes = {
  collection: object,
};

FiveVideoStories.storyLimit = 5;

export default FiveVideoStories;
